<div class="splash">
	<div class="loader splash__loader">
		<div></div>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="80"
			height="80"
			viewBox="0 0 80 80"
			fill="none"
		>
			<path
				d="M14.5442 14.5442C12.9821 12.9821 12.9705 10.4316 14.6808 9.03329C17.7019 6.56311 21.074 4.54371 24.6927 3.04482C29.5457 1.03463 34.7471 -1.31502e-06 40 0C45.2529 1.31502e-06 50.4543 1.03463 55.3073 3.04482C58.926 4.54372 62.2981 6.56312 65.3192 9.0333C67.0295 10.4316 67.018 12.9821 65.4559 14.5442C63.8938 16.1063 61.3745 16.0832 59.6298 14.728C57.376 12.9775 54.8935 11.5325 52.2459 10.4359C48.3635 8.82771 44.2023 8 40 8C35.7977 8 31.6366 8.8277 27.7541 10.4359C25.1066 11.5325 22.624 12.9775 20.3702 14.728C18.6256 16.0832 16.1063 16.1062 14.5442 14.5442Z"
				fill="#001849"
			></path>
		</svg>
	</div>
	<div class="splash__text trp-text__body--small">Just a moment...</div>
</div>
